import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import Vacancy from "@/entity/Settings/vacancy";
import { IVacancy, IVacancyListItem, VacancyResponseType } from "@/entity/Settings/vacancy.types";
import { IVacancyRepository } from "./VacancyRepository.types";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import qs from "qs";
import { SiteVacancyRequestType } from "@/form/Settings/site/vacancy.types";

export class VacancyRepository implements IVacancyRepository {
    async fetchAll(data?: FormData): Promise<IVacancy> {
        const response = await Api.get('/settings/vacancy/get', { 
            params: data, 
            paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
            }});
        const responseData = response.data as VacancyResponseType;
        return new Vacancy(responseData);
    }

    async fetchData(data: PaginationRequestType): Promise<IVacancyListItem> {

        const response = await Api.get(`/settings/vacancy/get`, {
            params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});

        const responseData = response.data as VacancyResponseType;

        return new Vacancy(responseData).data[0];
    }

    async create(data: SiteVacancyRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/settings/vacancy/create', data);
        return response.data;
    }

    async update(data: SiteVacancyRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/settings/vacancy/update`, data);
        const responseData = response.data;
        return responseData;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/settings/vacancy/delete`, data);
        const responseData = response.data;
        return responseData;
    }

}